<template>
  <div class="section2-container">
    <div class="box">
      <div class="separator">
        <img src="@images/border-white.png" />
      </div>
      <div class="product-box">
        <div class="row m-0">
          <div class="col-12 col-md image">
            <img src="@images/product/c-01.png" />
          </div>
          <div class="col-12 col-md article">
            <div>
              <div class="title color-green1">
                {{ $t("message.product.item[0].title") }}
              </div>
              <div class="text" style="border-color: #486A48">
                {{ $t("message.product.item[0].text") }}
              </div>
            </div>
          </div>
        </div>

        <div class="row m-0 flex-column-reverse flex-md-row">
          <div class="col-12 col-md article right">
            <div>
              <div class="title color-orange2">
                {{ $t("message.product.item[1].title") }}
              </div>
              <div class="text" style="border-color: #EC7733">
                {{ $t("message.product.item[1].text") }}
              </div>
            </div>
          </div>
          <div class="col-12 col-md image">
            <img src="@images/product/c-04.png" />
          </div>
        </div>

        <div class="row m-0">
          <div class="col-12 col-md image">
            <img src="@images/product/c-02.png" />
          </div>
          <div class="col-12 col-md article">
            <div>
              <div class="title color-yellow1">
                {{ $t("message.product.item[2].title") }}
              </div>
              <div class="text" style="border-color: #F3B12C">
                {{ $t("message.product.item[2].text") }}
              </div>
            </div>
          </div>
        </div>

        <div class="row m-0 flex-column-reverse flex-md-row">
          <div class="col-12 col-md article right">
            <div>
              <div class="title color-red1">
                {{ $t("message.product.item[3].title") }}
              </div>
              <div class="text" style="border-color: #CC2B38">
                {{ $t("message.product.item[3].text") }}
              </div>
            </div>
          </div>
          <div class="col-12 col-md image">
            <img src="@images/product/c-03.png" />
          </div>
        </div>

        <div class="row m-0 button">
          <router-link :to="{ name: 'Available' }" class="button1">
            {{ $t("message.product.button") }}
          </router-link>
        </div>
      </div>
      <div class="separator bottom">
        <img src="@images/border-white.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@scss/product/section2.scss";
</style>